// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"7810373ebf28c9e80712","339":"b8e8d3700219a22fa58f"}[chunkId] + ".js";
};